import React, { useState } from 'react';
import { Hero } from '../components/Hero';
import { PatternReveal } from '../components/PatternReveal';
import { MechanismSection } from '../components/MechanismSection';
import { IncludesSection } from '../components/IncludesSection';
import { AudienceSection } from '../components/AudienceSection';
import { FAQSection } from '../components/FAQSection';
import { CTABlock } from '../components/CTABlock';
import { TermsModal } from '../components/TermsModal';
export function SalesPage() {
  const [showTerms, setShowTerms] = useState(false);
  return <main className="min-h-screen w-full bg-[#FFFBF5]" data-id="element-162">
      <Hero data-id="element-163" />

      <div className="mx-auto max-w-3xl px-6 pb-16" data-id="element-164">
        <CTABlock scrollTo="descarga" subtext="Acceso inmediato · 100% Confidencial" data-id="element-165">
          SÍ, QUIERO CORTAR LA CULPA
        </CTABlock>
      </div>

      <PatternReveal data-id="element-166" />

      <MechanismSection data-id="element-167" />

      <IncludesSection data-id="element-168" />

      <AudienceSection data-id="element-169" />

      <div id="precio" className="bg-[#FFF3E8] px-6 py-16 text-center" data-id="element-170">
        <div className="mx-auto max-w-2xl" data-id="element-171">
          <h2 className="mb-6 font-serif text-3xl font-bold text-[#2D2420]" data-id="element-172">
            Lo que vas a notar cuando lo hagas
          </h2>
          <p className="mb-8 text-[#8B7D75]" data-id="element-173">(sin prometer milagros)</p>

          <ul className="mb-10 space-y-4 text-left text-lg text-[#2D2420] md:text-center" data-id="element-174">
            <li data-id="element-175">• Menos urgencia por "arreglarlo ya"</li>
            <li data-id="element-176">• Más capacidad de pausar sin colapsar</li>
            <li data-id="element-177">• Más claridad para ver patrones</li>
            <li data-id="element-178">• Menos vergüenza por sentir</li>
            <li data-id="element-179">• Límites simples que no dependen de convencer a nadie</li>
          </ul>

          <p className="mb-8 text-xl font-medium italic text-[#C4704B]" data-id="element-180">
            "Tu vida no se repara con explicaciones. Se repara con decisiones
            pequeñas sostenidas."
          </p>

          <div id="descarga" data-id="element-181">
            <CTABlock fullWidth subtext="Empieza hoy mismo" price="$110 MXN" originalPrice="$299 MXN" href="https://vialibre360.com/cart/46498032517278:1" data-id="element-182">
              DESCARGAR PROTOCOLO AHORA
            </CTABlock>
          </div>
        </div>
      </div>

      <FAQSection data-id="element-183" />

      <footer className="bg-[#2D2420] px-6 py-12 text-center text-[#E8DDD4]" data-id="element-184">
        <div className="mx-auto max-w-xl" data-id="element-185">
          <h3 className="mb-6 font-serif text-2xl font-bold text-white" data-id="element-186">
            La parte que duele (pero libera)
          </h3>
          <p className="mb-6" data-id="element-187">
            Tal vez hoy sigues ahí por amor. O por historia. O por hijos. O por
            miedo.
          </p>
          <p className="mb-8 font-medium text-[#C4704B]" data-id="element-188">
            Este protocolo no te empuja a irte ni a quedarte. Te devuelve algo
            más importante: la capacidad de no traicionarte.
          </p>

          <CTABlock className="mb-12" scrollTo="descarga" subtext="Garantía de 30 días" data-id="element-189">
            RECUPERAR MI CLARIDAD
          </CTABlock>

          <p className="text-sm text-[#8B7D75]" data-id="element-190">
            © 2024 No Estoy Loca. Todos los derechos reservados.
          </p>
          <button onClick={() => setShowTerms(true)} className="mt-3 text-sm text-[#8B7D75] underline decoration-[#E8DDD4] underline-offset-2 transition-colors hover:text-[#C4704B] hover:decoration-[#C4704B]" data-id="element-191">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <TermsModal isOpen={showTerms} onClose={() => setShowTerms(false)} data-id="element-192" />
    </main>;
}